import {
  Autocomplete,
  Box,
  Fade,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";

import { Loading } from "../../../common/components/Loading";
import { Calendar } from "../../../common/components";
import { getEquiposActivos } from "../../../helpers/equipos";
import { getCargos } from "../../../helpers/cargos";

export const InfoPersonal = ({ acolito, setAcolito }) => {
  const [equipos, setEquipos] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    const eq = await getEquiposActivos();
    setEquipos(eq);
    const car = await getCargos();
    setCargos(car);
    setLoading(false);
  };

  const handleFechaNacimiento = (value) => {
    setAcolito({ ...acolito, fecha_nacimiento: value.fecha });
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <Loading texto="Obteniendo información" />;
  }

  return (
    <Fade in={true} timeout={1000}>
      <Box sx={style.modal}>
        <Typography
          id="transition-modal-title"
          variant="h4"
          sx={style.modal_title}
          color="primary"
          fontWeight={900}
        >
          AGREGAR NUEVO ACÓLITO
        </Typography>
        <Box
          sx={{
            padding: 5,
            borderRadius: 7,
            //Agregar sombra
            boxShadow: 5,
            width: "50%",
            margin: "auto",
          }}
        >
          <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
            Datos personales
          </Typography>
          <Box sx={style.inputs}>
            <TextField
              label="Nombre"
              variant="outlined"
              value={acolito.nombre}
              required
              fullWidth
              onChange={(value) => {
                setAcolito({ ...acolito, nombre: value.target.value });
              }}
              sx={{ marginRight: 5 }}
            />
            <TextField
              id="standard-basic"
              label="Segundo nombre"
              variant="outlined"
              fullWidth
              value={acolito.nombre2 ? acolito.nombre2 : ""}
              onChange={(value) => {
                setAcolito({ ...acolito, nombre2: value.target.value });
              }}
            />
          </Box>
          <Box sx={style.inputs}>
            <TextField
              id="standard-basic"
              label="Apellido paterno"
              required
              variant="outlined"
              fullWidth
              value={acolito.apellido_p}
              onChange={(value) => {
                setAcolito({ ...acolito, apellido_p: value.target.value });
              }}
              sx={{ marginRight: 5 }}
            />
            <TextField
              id="standard-basic"
              label="Apellido materno"
              variant="outlined"
              required
              fullWidth
              value={acolito.apellido_m}
              onChange={(value) => {
                setAcolito({ ...acolito, apellido_m: value.target.value });
              }}
            />
          </Box>
          <Box sx={style.inputs}>
            <Calendar
              fecha={acolito.fecha_nacimiento ? acolito.fecha_nacimiento : ""}
              setFecha={handleFechaNacimiento}
              label={"Fecha de nacimiento"}
            />
          </Box>
          <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
            Información de contacto
          </Typography>
          <Box sx={style.inputs}>
            <TextField
              label="Celular"
              variant="outlined"
              required
              value={acolito.celular ? acolito.celular : ""}
              fullWidth
              onChange={(value) => {
                setAcolito({ ...acolito, celular: value.target.value });
              }}
              sx={{ marginRight: 5 }}
            />
            <TextField
              id="standard-basic"
              label="Correo"
              required
              variant="outlined"
              fullWidth
              value={acolito.correo ? acolito.correo : ""}
              onChange={(value) => {
                setAcolito({ ...acolito, correo: value.target.value });
              }}
            />
          </Box>
          <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
            Equipo actual
          </Typography>
          <Box sx={style.inputs}>
            <Autocomplete
              disablePortal
              // freeSolo
              options={equipos}
              value={
                equipos.find(
                  (equipo) => equipo.id === acolito.ID_equipo_actual
                ) || null
              }
              fullWidth
              sx={{ marginTop: 2 }}
              renderInput={(params) => (
                <TextField {...params} label="Seleccione un equipo" />
              )}
              getOptionLabel={(option) => option.nombre}
              isOptionEqualToValue={(option, value) => option === value}
              onChange={(event, value) => {
                value
                  ? setAcolito({ ...acolito, ID_equipo_actual: value.id })
                  : setAcolito({ ...acolito, ID_equipo_actual: null });
              }}
              noOptionsText="Sin resultados"
            />
          </Box>
          <Typography variant="h6" color="primary" sx={{ marginBottom: 3 }}>
            Información del Acólito
          </Typography>
          <Box
            sx={
              (style.inputs,
              {
                flexDirection: "column",
              })
            }
          >
            <Autocomplete
              disablePortal
              // freeSolo
              required
              options={cargos}
              value={
                cargos.find((cargo) => cargo.id === acolito.id_cargo) || null
              }
              fullWidth
              sx={{ marginTop: 2 }}
              renderInput={(params) => <TextField {...params} label="Rango" />}
              getOptionLabel={(option) => option.nombre}
              isOptionEqualToValue={(option, value) => option === value}
              onChange={(event, value) => {
                value
                  ? setAcolito({ ...acolito, id_cargo: value.id })
                  : setAcolito({ ...acolito, id_cargo: null });
              }}
              noOptionsText="Sin resultados"
            />
            <Typography
              variant="body1"
              color="secondary.dark"
              sx={{ marginTop: 2 }}
            >
              Cuenta con medalla
            </Typography>
            <FormControl
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <RadioGroup
                value={acolito.medalla}
                sx={{ display: "flex", flexDirection: "row" }}
                onChange={(value) => {
                  setAcolito({
                    ...acolito,
                    medalla: parseInt(value.target.value),
                  });
                }}
              >
                <FormControlLabel value="1" control={<Radio />} label="Sí" />
                <FormControlLabel value="0" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            <TextField
              id="standard-basic"
              label="Estatura (m)"
              variant="outlined"
              type="number"
              fullWidth
              value={acolito.estatura ? acolito.estatura : ""}
              onChange={(value) => {
                setAcolito({
                  ...acolito,
                  estatura: parseFloat(value.target.value),
                });
              }}
              sx={{ marginTop: 2, marginBottom: 2 }}
            />
          </Box>
          <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
            Estado del acólito
          </Typography>
          <Box sx={style.inputs}>
            <Switch
              checked={acolito.estatus === 1 ? false : true}
              onChange={(value) => {
                value.target.checked
                  ? setAcolito({ ...acolito, estatus: 0 })
                  : setAcolito({ ...acolito, estatus: 1 });
              }}
            />

            <Typography
              variant="body1"
              color={acolito.estatus === 1 ? "error" : "success"}
            >
              {acolito.estatus === 1 ? "Inactivo" : "Activo"}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

const style = {
  modal: {
    // position: "absolute",
    top: "50%",
    left: "50%",
    // transform: "translate(-50%, -50%)",
    // width: "65%",
    bgcolor: "background.paper",
    // boxShadow: 24,
    p: 4,
    // borderRadius: 2,
  },
  modal_title: {
    textAlign: "center",
    marginBottom: 5,
  },
  inputs: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
    justifyContent: "space-around",
  },
};
